// Auth layer — Magic Link via Supabase Auth + tenant context
import { supabase } from './http.js';
import { getCurrentTenant } from './tenant.js';

let _initialized = false;

export async function initAuth() {
  if (_initialized) return;
  _initialized = true;

  // Listener: persiste mudança de sessão
  supabase.auth.onAuthStateChange((event, session) => {
    if (event === 'SIGNED_IN' && session?.user) {
      console.info('[auth] signed in', session.user.email);
    }
    if (event === 'SIGNED_OUT') {
      console.info('[auth] signed out');
    }
  });
}

export async function getSession() {
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    console.error('[auth] getSession error', error);
    return null;
  }
  return data.session;
}

/**
 * Garante usuário autenticado. Se não estiver, redireciona para tela de login.
 * @param {{ loginUrl?: string }} opts
 */
export async function requireAuth(opts = {}) {
  const session = await getSession();
  if (session) return session;

  const loginUrl = opts.loginUrl || `https://app.zzyon.com/login?return=${encodeURIComponent(location.href)}`;
  location.href = loginUrl;
  // bloqueia chamadores
  return new Promise(() => {});
}

export async function signInWithMagicLink(email, redirectTo) {
  const { error } = await supabase.auth.signInWithOtp({
    email,
    options: { emailRedirectTo: redirectTo || location.origin }
  });
  if (error) throw error;
}

export async function signInWithGoogle(redirectTo) {
  const { error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      redirectTo: redirectTo || location.origin,
      queryParams: { access_type: 'offline', prompt: 'consent' }
    }
  });
  if (error) throw error;
}

export async function signOut() {
  await supabase.auth.signOut();
  location.reload();
}

export async function getCurrentUser() {
  const session = await getSession();
  return session?.user || null;
}

/**
 * Combina user + tenant em um único snapshot (usado pelo header).
 */
export async function getAuthContext() {
  const [session, tenant] = await Promise.all([getSession(), getCurrentTenant()]);
  return {
    user: session?.user || null,
    session,
    tenant
  };
}
